import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsAlpha({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" id="&#206;&#177;" d="M13.9761 11.6418C13.4425 11.7836 12.9647 11.8545 12.5427 11.8545C11.149 11.8545 10.2093 10.8694 9.72355 8.89925H9.66382C8.54096 10.9664 6.96815 12 4.94539 12C3.44824 12 2.24972 11.4664 1.34983 10.3993C0.449943 9.32463 0 7.97015 0 6.33582C0 4.47015 0.513652 2.94776 1.54096 1.76866C2.56826 0.589552 3.95791 0 5.7099 0C6.65757 0 7.50171 0.246269 8.24232 0.738806C8.98293 1.23134 9.54437 1.92537 9.92662 2.8209H9.9744L10.8823 0.268657H13.7253L11.2764 5.97761C11.5472 7.39552 11.8339 8.36194 12.1365 8.87687C12.4391 9.38433 12.8333 9.63806 13.3191 9.63806C13.5819 9.63806 13.8089 9.60075 14 9.52612L13.9761 11.6418ZM9.01877 5.88806C8.76394 4.64925 8.36974 3.70149 7.83618 3.04478C7.31058 2.3806 6.67747 2.04851 5.93686 2.04851C4.98123 2.04851 4.21672 2.44776 3.64334 3.24627C3.07793 4.03731 2.79522 5.01493 2.79522 6.1791C2.79522 7.23134 3.04209 8.11194 3.53584 8.8209C4.02958 9.52985 4.69056 9.88433 5.51877 9.88433C6.21957 9.88433 6.85665 9.58209 7.43003 8.97761C8.01138 8.37313 8.49317 7.48507 8.87543 6.31343L9.01877 5.88806Z" fill="currentColor" /></Svg>;
}
export default OrdinalsAlpha;